import { render, staticRenderFns } from "./ApprovalDialog.vue?vue&type=template&id=cef83e26&scoped=true"
import script from "./ApprovalDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalDialog.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDialog.vue?vue&type=style&index=0&id=cef83e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef83e26",
  null
  
)

export default component.exports